import Vue from 'vue';
import Router from 'vue-router';
import App from './App.vue';
import routes from './routes';
import {checkRouteLogin} from './routes/before_each';
import store from '@/store';
import ElementResizeDetectorMaker from 'element-resize-detector';
import {applyVuex} from 'vuereact-combined';
import weirwoodCommon from '../weirwood.json';
import {weirwoodOption} from './common/weirwood';
import VueLazyload from 'vue-lazyload';
import * as Weirwood from '@baidu/weirwood-sdk';

import './common/baiduTongji';
import './common/circular';

// react_app中使用Vuex https://www.npmjs.com/package/vuereact-combined#applyvuex
applyVuex(store);

Vue.config.productionTip = false;
Vue.use(Router);
Vue.use(VueLazyload, {
    loading: require('./assets/loadingProgress.png')
});
Vue.prototype.$erd = new ElementResizeDetectorMaker();

const router = new Router({
    mode: 'history',
    routes
});

router.beforeEach(checkRouteLogin);

const weirwoodOptions = {
    common: {
        buildid: weirwoodCommon.buildid,
        token: weirwoodCommon.token
    },
    ...weirwoodOption
};
const weirwood = Weirwood.init(weirwoodOptions);
Vue.config.errorHandler = function (err) {
    weirwood.error.captureException(err);
};

// 先加载用户信息， 再初始化app
new Vue({
    router,
    store,
    render: h => h(App, {
        on: {
            expose(...args) {
                console.log('[EVENT]', ...args);
            }
        }
    })
}).$mount('#app');
